import { gql } from '@apollo/client';
export const connectEsigningProvider = gql `
  mutation ConnectEsigningProvider($providerId: UUID!) {
    connectEsigningProvider(esigning_provider_id: $providerId)
  }
`;
